import React, { useState, useRef, useEffect } from "react";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const years = Array.from({ length: 50 }, (_, i) => 2000 + i); // Years from 2000 to 2049

const CustomDatePicker = ({
  value,
  onChange,
  defaultYear = new Date().getFullYear(),
  defaultMonth = new Date().getMonth(),
  placeholder = "Select Date",
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [selectedYear, setSelectedYear] = useState(defaultYear);
  const calendarRef = useRef(null);

  // Sync state with prop value
  useEffect(() => {
    if (value) {
      const dateObj = new Date(value);
      setSelectedMonth(dateObj.getMonth());
      setSelectedYear(dateObj.getFullYear());
    }
  }, [value]);

  // Handle date selection
  const handleDateSelect = (day) => {
    const formattedDate = `${selectedYear}-${String(selectedMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    onChange(formattedDate);
    setShowCalendar(false);
  };

  // Close calendar if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Get number of days in selected month/year
  const getDaysInMonth = (month, year) =>
    new Date(year, month + 1, 0).getDate();

  return (
    <div className="relative">
      {/* Date Input Field */}
      <input
        type="text"
        value={value || ""}
        onFocus={() => setShowCalendar(true)}
        readOnly
        placeholder={placeholder}
        className="w-full h-10 px-4 border border-gray-300 rounded-md cursor-pointer"
      />

      {/* Custom Calendar Popup */}
      {showCalendar && (
        <div
          ref={calendarRef}
          className="absolute left-0 mt-2 w-[300px] bg-[#088F8F] text-white rounded-md shadow-lg p-4 z-10"
        >
          {/* Month & Year Selection */}
          <div className="flex justify-between items-center mb-2">
            <select
              className="bg-transparent border-none text-white text-xl cursor-pointer"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(Number(e.target.value))}
            >
              {months.map((month, index) => (
                <option key={index} value={index} className="text-black">
                  {month}
                </option>
              ))}
            </select>
            <select
              className="bg-transparent border-none text-white text-sm cursor-pointer"
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              {years.map((year) => (
                <option key={year} value={year} className="text-black">
                  {year}
                </option>
              ))}
            </select>
          </div>

          {/* Days Grid */}
          <div className="grid grid-cols-7 text-center text-xs font-light">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
              (day, index) => (
                <div key={index} className="py-1">
                  {day}
                </div>
              ),
            )}
          </div>
          <div className="grid grid-cols-7 text-center ">
            {Array.from(
              { length: getDaysInMonth(selectedMonth, selectedYear) },
              (_, i) => i + 1,
            ).map((day) => (
              <div
                key={day}
                className="py-4 cursor-pointer hover:bg-white hover:text-[#088F8F] rounded-full"
                onClick={() => handleDateSelect(day)}
              >
                {day}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDatePicker;
